export const MAX_TEAMS_ALLOWED = 100;
